import { ComponentType } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from 'src/constants/routes';
import { useAuth } from '../../hooks';
import { Appeals } from '../appeals';
import { Applications } from '../applications';
import { Attestation } from '../attestation';
import { Certificates } from '../certificates';
import { Checking } from '../checking';
import { Commissions } from '../commissions';
import { Directions } from '../directions';
import { Instructions } from '../instructions';
import { Locations } from '../locations';
import Notifications from '../notifications/Notifications';
import { Organizations } from '../organizations';
import { PersonalInfo } from '../personal-info';
import { Regions } from '../regions';
import { Reports } from '../reports';
import { Schedules } from '../schedules';
import { Specialities } from '../specialities';
import { Test, TestExam } from '../test';
import { Tests } from '../tests';
import { Users } from '../users';

export const Cabinet: ComponentType = () => {
  const { user, handleGetOwnerUpdate } = useAuth();

  return (
    <Switch>
      <Route path={ROUTES.APPLICATIONS.ROOT} component={Applications} />
      <Route path={ROUTES.TEST.ROOT} component={Test} />
      <Route path={ROUTES.EXAM} component={TestExam} exact />
      <Route path={ROUTES.APPEALS.ROOT} component={Appeals} />
      <Route path={ROUTES.CERTIFICATES} component={Certificates} exact />
      <Route path={ROUTES.CHECKING} component={Checking} exact />
      <Route path={ROUTES.INSTRUCTIONS} component={Instructions} exact />

      <Route path={ROUTES.USERS} component={Users} exact />
      <Route path={ROUTES.ORGANIZATIONS} component={Organizations} exact />
      <Route path={ROUTES.LOCATIONS} component={Locations} exact />
      <Route path={ROUTES.TESTS} component={Tests} exact />
      <Route path={ROUTES.SCHEDULES} component={Schedules} exact />

      <Route path={ROUTES.ATTESTATION} component={Attestation} exact />

      <Route path={ROUTES.REFERENCES.ROOT} component={Directions} exact />
      <Route path={ROUTES.REFERENCES.DIRECTIONS} component={Directions} exact />
      <Route path={ROUTES.REFERENCES.REGIONS} component={Regions} exact />
      <Route path={ROUTES.REFERENCES.COMMISSIONS} component={Commissions} exact />

      {/* <Route path={ROUTES.REFERENCES.DISTRICTS} component={Districts} exact /> */}
      <Route path={ROUTES.REPORTS} component={Reports} exact />
      <Route path={ROUTES.REFERENCES.SPECIALTIES} component={Specialities} exact />
      <Route path={ROUTES.NOTIFICATIONS} component={Notifications} exact />

      <Route>
        <PersonalInfo onUpdate={handleGetOwnerUpdate} {...user} />
      </Route>
    </Switch>
  );
};
